import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SrvSurvivors } from '../../models/Survivors/SrvSurvivors';
import { MohHttpClient } from 'moh-package';

@Injectable()
export class SurvivorsService {

  constructor(private http: HttpClient, private mohHttpClient: MohHttpClient) {
  }

  SendSurvivorsRequest(survivorsObj: SrvSurvivors) {

    return this.mohHttpClient.post("/Api/Survivors/SendSurvivorsRequest", survivorsObj, { showSpinner: true })

      .map((res: Response) => {

        return res;
      });
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/services/survivors/survivors.service.ts